import classnames from "classnames";
import React, { useState, useEffect } from "react";
import LazyModal from "web/react/components/lazy-modal/lazy-modal";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import styles from "./generic-modal.css";

interface GenericModalProps {
    children: JSX.Element;
    isOpen: boolean;
    onAfterOpen?: () => void;
    onClose: () => void;
    className?: string;
    overlayClassName?: string;
    fullscreen?: boolean;
    closable?: boolean;
    noScroll?: boolean;
    animateModal?: boolean;
}

function GenericModal({
    children,
    isOpen,
    onAfterOpen,
    onClose,
    className,
    overlayClassName,
    fullscreen = false,
    closable = true,
    noScroll,
    animateModal = false,
}: GenericModalProps): null | JSX.Element {
    const [animate, setAnimate] = useState(false);
    const [startAnimate, setStartAnimate] = useState(false);

    useEffect(() => {
        if (startAnimate) {
            setTimeout(() => {
                setAnimate(true);
            }, 100);
        }
    }, [startAnimate]);

    let appElement: HTMLElement | undefined;
    if (document.body) {
        appElement = document.body.querySelector<HTMLDivElement>(".site-wrapper") || undefined;
    }

    return (
        <LazyModal
            appElement={appElement}
            className={classnames(styles.modal, className, {
                [styles.fullscreen]: fullscreen,
                [styles.animate]: startAnimate,
                [styles.doAnimate]: animate,
            })}
            noScroll={noScroll}
            isOpen={isOpen}
            onAfterOpen={(): void => {
                onAfterOpen && onAfterOpen();
                animateModal && setStartAnimate(true);
            }}
            onRequestClose={onClose}
            overlayClassName={classnames(styles.overlay, overlayClassName)}
            shouldCloseOnOverlayClick={closable}
            shouldCloseOnEsc={closable}
        >
            {closable && (
                <div className={styles.closeContainer}>
                    <CloseButton onClick={onClose} />
                </div>
            )}
            {children}
        </LazyModal>
    );
}

export default GenericModal;
